<template>
    <div class="bg-light wrapper--iframe position-relative overflow-hidden">
        <iframe
            :src="url"
            class="position-absolute top left border-0 h-100 w-100"
            @load.once="$emit('accessed')"
        />
    </div>
</template>

<script setup>
import { useListenerManager } from "front-toolkit/plugins/ListenersPlugin"

defineProps({
    url: {
        type: String,
        required: true,
    },
})
const emit = defineEmits(["accessed", "close"])

const { listen } = useListenerManager()

listen("message", event => {
    if (
        event.origin === window.location.origin &&
        typeof event.data === "object" &&
        event.data.type === "prometeo:scorm:window-closed"
    ) {
        emit("close")
    }
})
</script>

<style scoped>
.wrapper--iframe {
    height: calc(100vh - 50px);
}
</style>
